import {action, makeObservable, observable} from "mobx";

export class FolderStore {
    id = "";
    title = "";
    folderCount = 0;
    lastUpdated = "";
    lastUpdatedTooltip = "";
    isSelected = false;
    isHovered = false;
    //data from contract
    folder_uuid = "";
    name = "";
    internal_name = "";
    path = "";
    is_active = false;
    created_at = "";
    updated_at = "";
    parent_folder_uuid = "";
    sharedCountWith = 0;

    constructor({ id, title, folderCount, lastUpdated, lastUpdatedTooltip, folder_uuid, name, internal_name, path, is_active, created_at, updated_at, parent_folder_uuid, sharedCountWith }) {
        makeObservable(this, {
            id: observable,
            title: observable,
            folderCount: observable,
            lastUpdated: observable,
            lastUpdatedTooltip: observable,
            isSelected: observable,
            isHovered: observable,
            setHover: action,
            setSelected: action,
            setName: action,
            //data from contract
            folder_uuid: observable,
            name: observable,
            internal_name: observable,
            path: observable,
            is_active: observable,
            created_at: observable,
            updated_at: observable,
            parent_folder_uuid: observable,
            sharedCountWith: observable,
        });

        this.id = id;
        this.title = title;
        this.folderCount = folderCount;
        this.lastUpdated = lastUpdated;
        this.lastUpdatedTooltip = lastUpdatedTooltip;
        //data from contract
        this.folder_uuid = folder_uuid;
        this.name = name;
        this.internal_name = internal_name;
        this.path = path;
        this.is_active = is_active;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.parent_folder_uuid = parent_folder_uuid;
        this.sharedCountWith = sharedCountWith || 0;
    }

    setHover(value){
        this.isHovered = value;
    }

    setSelected(value){
        this.isSelected = value;
    }

    setName(name){
        this.name = name;
    }
}